import React, { Component } from 'react'
import { connect } from 'react-redux'
import CensusPopup from '../../formComponents/censusPopup'
import * as actionCreators from '../../actions'

class Warning extends Component {

  render() {
    const {
      updateFieldValidationObject,
      warningValue,
      fieldValidations,
      merchandiseId,
      warningindexk
    } = this.props
    const fieldItems = fieldValidations.filter((obj) => {
      if(obj.fieldId){
        let fieldId = obj.fieldId;
        // if(obj.fieldId.includes(",")){
        //   fieldId = obj.fieldId.split(",")[0]
        // }
        return obj.merchandiseId === merchandiseId && fieldId === this.props.combinedField && obj.ApplicableWarningCode === this.props.code
      }
      
    })

    if (fieldItems.length) {
      // const warning = this.props.warnings.find(
      //   x => x[fieldItem.ApplicableWarningCode]
      // )
      return fieldItems.map((fieldItem)=>{
        const key = fieldItem.ApplicableWarningCode+"_"+fieldItem.merchandiseId;
        const warning = this.props.warnings[key];
          if (warning && (fieldItem.valueChanged === 2 || 'undefined') || warning && fieldItem.valueChanged === 1) {
            if (fieldItem.isWarningResolved === 2 && !fieldItem.overrideCodeUsed || fieldItem.isWarningResolved === 2 &&
              fieldItem.overrideCodeUsed || fieldItem.isWarningResolved === 1) {
              return (
                <React.Fragment key={key+"keyxyz"+warningindexk}>
                  {
                    warning && 
                  
                  <CensusPopup
                    code={warning.code}
                    warningDetails={warning}
                    field={fieldItem}
                    updateFieldValidationObject={updateFieldValidationObject}
                    warningValue={warningValue}
                    invoiceIndex={this.props.invoiceIndex}
                    lineItemIndex={this.props.lineItemIndex}
                    dutyItemIndex={this.props.dutyItemIndex}
                    merchandiseId={merchandiseId}
                  />
                  }
                </React.Fragment>
              )
            } else return null
          } else return null
      })
      
    } else return null
  }
}
const mapStateToProps = (state, props) => {
  return {
    fieldValidations: state.FieldValidation?.fields || props?.fieldValidations?.fields || [],
    warnings: state.FieldValidation?.census_warnings || props?.fieldValidations?.census_warnings || []
  }
}

const mapDispatchToProps = {
  ...actionCreators
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Warning)

